import React, { useEffect, useState } from "react";
import { Button } from "../../../../_helpers/components/Button";
import { useNavigate, useParams } from "react-router-dom";
import { EventAdminView } from "./EventAdminView";
import { EventUserView } from "./EventUserView";
import { useOutletContext } from "react-router-dom";
import { formatDate } from "../../../../_helpers/functions";
import { getEvent } from "../../../../_api/Event";

export const Event = () => {
    const navigate = useNavigate();

    const [user, setUser, currentApp, currentMenu] = useOutletContext();
    const { id, status } = useParams(); // Récupération du paramètre status
    const [event, setEvent] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [selectedDate, setSelectedDate] = useState(null);

    const features_right = user.policy.rights[currentApp][currentMenu.id]["sub_menu"]["MAIN"]["features"];

    const splitContactValues = (value) => {
        if (!value || typeof value !== "string") return [];
        return value
            .split(/[ ,;]+/g)
            .map((v) => v.trim())
            .filter(Boolean);
    };

    const reloadEvent = () => {
        getEvent(id, status).then((resp) => {
            setEvent(resp.data);
            setIsLoading(false);
        });
    };

    useEffect(() => {
        if (id) {
            getEvent(id, status).then((resp) => {
                setEvent(resp.data);
                setIsLoading(false);
                const eventDays = getUniqueDays(resp.data.shifts);
                if (eventDays.length > 0) {
                    setSelectedDate(eventDays[0]);
                }
            });
        }
    }, [id]);

    const getUniqueDays = (shifts) => {
        const uniqueMap = new Map();
        
        if ((!shifts) || (shifts.length === 0)) {
            return [];
        };
        
        shifts.forEach((s) => {
            
            if (status ? (s.status === status || !s.status) : true) {
                const label = formatDate(new Date(s.start_time));
                if (!uniqueMap.has(label)) {
                    uniqueMap.set(label, { label, value: s.start_time });
                }
            }
        });
        
        const uniqueDays = Array.from(uniqueMap.values()).sort(
            (a, b) => new Date(a.value) - new Date(b.value)
        );
        return uniqueDays;
    };

    const filteredShifts =
        event?.shifts.filter((shift) => {
            const isStatusMatch = status ? shift.status === status : true;
            return isStatusMatch;
        }).sort(
            (a, b) => new Date(a.start_time) - new Date(b.start_time)
        ) || [];

    const filteredBoth =
        event?.shifts.filter((shift) => {
            const isDateMatch = selectedDate
                ? formatDate(new Date(shift.start_time)) === selectedDate.label
                : true;
            const isStatusMatch = status ? shift.status === status : true;
            return isDateMatch && isStatusMatch;
        }).sort(
            (a, b) => new Date(a.start_time) - new Date(b.start_time)
        ) || [];

    const labelType = {
        INTERNAL: "Interne",
        PRIVATE: "Privé",
        PUBLIC: "Public",
        MECENAT: "Mécénat",
        OVERTIME: "H. supp.",
    };

    return (
        <div className="w-full">
            <div className="p-4 pb-0 mb-0 flex justify-between">
                <div>
                    <Button
                        type="empty"
                        name="&#8604; Retour"
                        action={() =>
                            navigate("/manifestation/manifestations#PENDING")
                        }
                    />
                </div>

                {event?.group && (
                    <div className="text-right text-sm ml-4">
                        {event.group.contact_name && (
                            <div>👤 {event.group.contact_name}</div>
                        )}
                        {splitContactValues(event.group.contact_email).length > 0 && (
                            <div>
                                ✉️{" "}
                                {splitContactValues(event.group.contact_email).map((email, idx, arr) => (
                                    <React.Fragment key={idx + email}>
                                        <a href={"mailto:" + email}>{email}</a>
                                        {idx < arr.length - 1 ? " " : null}
                                    </React.Fragment>
                                ))}
                            </div>
                        )}
                        {splitContactValues(event.group.contact_phone).length > 0 && (
                            <div>
                                📞{" "}
                                {splitContactValues(event.group.contact_phone).map((phone, idx, arr) => (
                                    <React.Fragment key={idx + phone}>
                                        <a href={"tel:" + phone}>{phone}</a>
                                        {idx < arr.length - 1 ? " " : null}
                                    </React.Fragment>
                                ))}
                            </div>
                        )}

                    </div>
                )}
            </div>
            {event?.comment &&
                <div className="m-4 p-3 rounded-md bg-red-50 border border-red-600 text-red-600 text-sm text-left">
                    <p className="font-semibold">Commentaire :</p>
                    <p className="whitespace-pre-line">{event.comment}</p>
                </div>
            }
            {isLoading && "Chargement..."}
            {!isLoading && event && (
                <div>
                    <div className="shadow-lg flex overflow-x-auto text-nowrap gap-2 p-4">
                        <button
                            className={`px-4 py-2 rounded-lg text-sm font-semibold cursor-pointer ${!selectedDate
                                ? "bg-blue-500 text-white"
                                : "bg-gray-200 text-gray-700"
                                }`}
                            onClick={() => setSelectedDate(null)}
                        >
                            Toutes les dates
                        </button>

                        {getUniqueDays(filteredShifts).map(
                            (date, index) => (
                                <button
                                    key={index}
                                    className={`px-4 py-2 rounded-lg text-sm font-semibold cursor-pointer ${selectedDate?.label === date.label
                                        ? "bg-blue-500 text-white"
                                        : "bg-gray-200 text-gray-700"
                                        }`}
                                    onClick={() => {
                                        setSelectedDate({
                                            value: date.value,
                                            label: date.label,
                                        });
                                    }}
                                >
                                    {date.label}
                                </button>
                            )
                        )}
                    </div>
                    <div className=" bg-gray-100 flex items-center justify-center pt-0">
                        <div className="w-full bg-white shadow-lg p-6 flex flex-col md:flex-row">
                            {/* Section gauche : Détails de l'événement */}
                            <div className="md:w-1/3 w-full pr-0 md:pr-6 border-b md:border-b-0 md:border-r">
                                <img
                                    src="https://static.nationalgeographic.fr/files/styles/image_3200/public/93247.jpg?w=1900&h=1425"
                                    alt="Event Image"
                                    className="mb-4 rounded-lg w-full hidden lg:block"
                                />
                                <h1 className="text-2xl font-bold mb-4">
                                    Evènement : {event.name}
                                </h1>
                                <div>
                                    <strong>Date :</strong>{" "}
                                    <ul className="p-0">
                                        {getUniqueDays(
                                            selectedDate
                                                ? [
                                                    {
                                                        start_time:
                                                            selectedDate.value,
                                                    },
                                                ]
                                                : filteredShifts
                                        ).map((jour, index) => {
                                            return (
                                                <li key={index}>
                                                    {jour.label}
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </div>
                                <div>
                                    <strong>Type :</strong>{" "}
                                    {labelType[event.type]}
                                </div>
                                <div>
                                    <strong>Service :</strong>{" "}
                                    {event?.group?.description ||
                                        "Non attribué"}
                                </div>
                                <div>
                                    <strong>Commanditaire :</strong>{" "}
                                    {event.commandite}
                                </div>
                            </div>

                            {/* Section droite : Créneaux avec Tabs */}
                            <div className="flex-1 m-2">
                                {!features_right["admin_view"] ? (
                                    <EventUserView
                                        shifts={filteredBoth}
                                        reloadEvent={reloadEvent}
                                    />
                                ) : (
                                    <EventAdminView
                                        shifts={filteredBoth}
                                        reloadEvent={reloadEvent}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};
